import script from "./Pinned.vue?vue&type=script&setup=true&lang=ts"
export * from "./Pinned.vue?vue&type=script&setup=true&lang=ts"

import "./Pinned.vue?vue&type=style&index=0&id=3375740e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3375740e"]])

export default __exports__